/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentParcelsParcelidQueryResponse,
  GetApiV1IndividualpaymentParcelsParcelidPathParams,
  GetApiV1IndividualpaymentParcelsParcelidQueryParams,
  GetApiV1IndividualpaymentParcelsParcelid400,
  GetApiV1IndividualpaymentParcelsParcelid401,
  GetApiV1IndividualpaymentParcelsParcelid404,
  GetApiV1IndividualpaymentParcelsParcelid500,
} from "../../types/individualPaymentParcelsController/GetApiV1IndividualpaymentParcelsParcelid.ts";

function getGetApiV1IndividualpaymentParcelsParcelidUrl(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidPathParams["parcelId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/parcels/${parcelId}` as const,
  };
  return res;
}

/**
 * @description Devolve a parcela com exatamente os campos que o PUT parcels/{parcelId} aceita, mais os textos traduzidos ('typeText', 'statusText', 'paymentMethodText'), o contexto somente leitura (pagamento, estorno, prorrogação, datas de integração bancária e eNotas) e a auditoria ('userCreation', 'creationDate', 'userLastChange', 'lastChangeDate'). Use este endpoint para carregar o formulário: o PUT é full-replace e 'fine', 'totalDiscount', 'retroactiveDiscount', 'message', 'invoiceIssueDate' e 'fractionOfParcel' não são devolvidos pela grid de parcelas. 404 quando a parcela não existe. Sem equivalente no legado (o GET IndividualPayment/EditParcel apenas renderizava a view). **(Requer Authorization para autenticação)**
 * @summary Retorna uma parcela no formato aceito pela edição (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId}
 */
export async function getApiV1IndividualpaymentParcelsParcelid(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidPathParams["parcelId"],
  params?: GetApiV1IndividualpaymentParcelsParcelidQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentParcelsParcelidQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentParcelsParcelid400
      | GetApiV1IndividualpaymentParcelsParcelid401
      | GetApiV1IndividualpaymentParcelsParcelid404
      | GetApiV1IndividualpaymentParcelsParcelid500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentParcelsParcelidUrl(
      parcelId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
